import './documenti-correlati.scss';

/**
 * version    1.0
 * class      <type> (DocumentiCorrelati)
 * classdesc  Component that manage documenti correlati section
 */
export class DocumentiCorrelati {
  constructor(selector = '.documenti-correlati') {
    this.sections = document.querySelectorAll(selector);
    this.breakpoint = 992; // lg bootstrap
    this.init();
  }

  init() {
    if (!this.sections.length) return;

    this.sections.forEach((section) => {
      const cards = section.querySelectorAll('.cdp-card--download');
      const toggle = section.querySelector('.documenti-correlati__toggle');
      const list = section.querySelector('.documenti-correlati__list');

      if (!cards.length || !toggle || !list) return;

      if (cards.length > 3) {
        section.classList.add('is-collapsible');

        toggle.addEventListener('click', () => {
          if (window.innerWidth < this.breakpoint) {
            section.classList.toggle('is-open');
          }
        });
      }

      // reset stato se resize desktop
      window.addEventListener('resize', () => {
        if (window.innerWidth >= this.breakpoint) {
          section.classList.remove('is-open');
        }
      });
    });
  }
}
